import { useSyncExternalStore } from 'react'
import { getModelVersion, subscribeModel } from '../model/registry'

/**
 * The model version the registry currently holds (30.03.06). For the few
 * places that derive something from the model and must re-derive when it
 * changes — the route table, the fast-nav list — memoize on this.
 *
 * Ordinary consumers do not need it: they call getModel() at render time, and
 * the registry only changes on a navigation, which renders anyway.
 */
export default function useModelVersion() {
    return useSyncExternalStore(subscribeModel, getModelVersion)
}
